module.exports = __webpack_public_path__ + "media/images/icon/place-c03ce4435f8b82252dfb2fc3376c92e3.svg";